<template>
  <v-container>
    <template>
      <div class="text-center">
        <v-dialog
          persistent
          v-model="dialog"
          :retain-focus="false"
          width="1200px"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">
                Create Order
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closeModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text class="black--text">
              <v-row class="pt-8">
                <v-col lg="4" md="4" sm="4" xs="12">
                  <label class="subtitle-1 font-weight-medium"
                    >Supplier Name</label
                  >
                  <v-select
                    v-model="order.supplierId"
                    outlined
                    dense
                    placeholder="Supplier Name"
                    :items="suppliers"
                    item-text="supplierName"
                    item-value="id"
                    :hide-details="true"
                  ></v-select>
                </v-col>
                <v-col lg="4" md="4" sm="4" xs="12">
                  <label class="subtitle-1 font-weight-medium"
                    >Order Date</label
                  >
                  <v-menu
                    v-model="orderDateModel"
                    :close-on-content-click="true"
                    :nudge-right="20"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="order.orderDate"
                        placeholder="Select Date"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        v-on:click:append="orderDateModel = true"
                        outlined
                        dense
                        append-icon="mdi-calendar-blank-outline"
                        :hide-details="true"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="order.orderDate"
                      @input="orderDateModel = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col lg="4" md="4" sm="4" xs="12">
                  <label class="subtitle-1 font-weight-medium"
                    >Receive Order Date</label
                  >
                  <v-menu
                    v-model="receivedDateModel"
                    :close-on-content-click="true"
                    :nudge-right="20"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="order.receivedDate"
                        placeholder="Select Date"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        v-on:click:append="receivedDateModel = true"
                        outlined
                        dense
                        append-icon="mdi-calendar-blank-outline"
                        :hide-details="true"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="order.receivedDate"
                      :min="order.orderDate"
                      @input="receivedDateModel = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="8">
                  <label class="subtitle-1 font-weight-medium"
                    >Drop your Reciept</label
                  >
                  <div class="text-center">
                    <div v-if="!order.receiptImageUrl">
                      <div
                        :class="['dropZone', dragging ? 'dropZone-over' : '']"
                        @dragenter="dragging = true"
                        @dragleave="dragging = false"
                      >
                        <div class="dropZone-info" @drag="onOrderReceiptChange">
                          <span class="dropZone-title">
                            Drag and drop here or
                          </span>
                          <span
                            class="fa fa-cloud-upload dropZone-title green--text font-weight-bold"
                            >Browse
                            <v-icon class="green--text"
                              >mdi-export-variant</v-icon
                            >
                          </span>
                        </div>
                        <input type="file" @change="onOrderReceiptChange" />
                      </div>
                    </div>
                    <div v-else class="dropZone-uploaded">
                      <div class="dropZone-uploaded-info">
                        <img class="image-preview" :src="previewUrl" />
                        <button
                          type="button"
                          class="btn btn-primary removeFile"
                          @click="removeOrderReceipt"
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <label class="subtitle-1 font-weight-medium"
                    >Select Ingredients</label
                  >
                  <v-autocomplete
                    :items="ingredients"
                    item-text="name"
                    item-value="id"
                    outlined
                    dense
                    multiple
                    chips
                    deletable-chips
                    placeholder="Select Ingredients"
                    v-model="selected"
                    @change="addOnIngredientsArr"
                    width="10"
                  >
                    <template v-slot:prepend-item>
                      <v-text-field
                        @input="searchIngredient"
                        v-model="search"
                        dense
                        class="py-3 px-4"
                        outlined
                        prepend-inner-icon="mdi-magnify"
                        placeholder="Search by name e.g barley grain"
                        :hide-details="true"
                      >
                      </v-text-field>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row class="px-3">
                <v-col
                  class="px-4 subtitle-2"
                  v-for="item in ingredientsListHeader"
                  :key="item.value"
                  style="background-color: #ffb443"
                >
                  {{ item.text }}
                </v-col>
              </v-row>
              <template v-if="order.ingredientOrderDetails.length">
                <v-row
                  v-for="(item, index) in order.ingredientOrderDetails"
                  :key="index"
                >
                  <v-col>
                    <v-text-field
                      outlined
                      dense
                      v-model="item.name"
                      disabled
                      :hide-details="true"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      outlined
                      dense
                      placeholder="200kg"
                      type="number"
                      v-model="item.quantity"
                      :hide-details="true"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      outlined
                      dense
                      placeholder="$150"
                      v-model="item.cost"
                      :hide-details="true"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      outlined
                      dense
                      placeholder="$2.5"
                      v-model="item.tax"
                      :hide-details="true"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col>
                    <v-menu
                      v-model="expiryDateModel[item.name]"
                      :close-on-content-click="true"
                      :nudge-right="20"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="item.expiryDate"
                          placeholder="Select Date"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          v-on:click:append="expiryDateModel[item.name] = true"
                          outlined
                          dense
                          append-icon="mdi-calendar-blank-outline"
                          :hide-details="true"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="item.expiryDate"
                        @input="expiryDateModel[item.name] = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col>
                    <v-btn
                      icon
                      color="#FF0000"
                      @click="removeIngredientsArr(item.id)"
                    >
                      <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </template>
              <template v-else>
                <v-row justify="center">
                  <h3 class="pa-3">Please select at least one ingredient</h3>
                </v-row>
              </template>
              <hr class="mt-6 mb-4" />
              <v-card-actions style="padding-right: 0">
                <v-spacer></v-spacer>
                <v-btn
                  outlined
                  class="mr-2"
                  right
                  depressed
                  color="primary"
                  @click="closeModal()"
                >
                  Cancel
                </v-btn>
                <v-btn right color="primary" @click="createOrder()">
                  Update Now
                </v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </v-container>
</template>
<script>
import loadingMixin from "@/mixins/LoadingMixin";
import S3UploadServce from "@/_services/S3UploadService";
import gql from "graphql-tag";

export default {
  apollo: {
    suppliers: {
      query: gql`
        query getSuppliers {
          getSuppliers {
            id
            supplierName
          }
        }
      `,
      update: (data) => data.getSuppliers,
    },
    ingredients: {
      query: gql`
        query getIngredientsByFarmId($farmId: Int!) {
          getIngredientsByFarmId(farmId: $farmId) {
            name
            id
          }
        }
      `,
      variables() {
        return {
          farmId: parseInt(localStorage.getItem("farmID")) || 0,
        };
      },
      update: (data) => data.getIngredientsByFarmId,
    },
  },

  data() {
    return {
      search: "",
      nowDate: new Date().toISOString().slice(0, 10),
      orderDateModel: false,
      receivedDateModel: false,
      expiryDateModel: {},
      dragging: false,
      ingredientsListHeader: [
        {
          text: "Ingredient Name",
          value: "name",
        },
        {
          text: "Quantity",
          value: "quantity",
        },
        {
          text: "Cost",
          value: "cost",
        },
        {
          text: "Tax",
          value: "tax",
        },
        {
          text: "Expiry",
          value: "expiry",
        },
        {
          text: "",
          value: "action",
        },
      ],
      order: {
        supplierId: "",
        orderDate: "",
        receivedDate: "",
        receiptImageUrl: "",
        //TODO::
        farmId: 345, //static data here, need to update with primary farm
        ingredientOrderDetails: [],
      },
      ingredients: [],
      farmId: null,
      suppliers: [],
      selected: [],
      searchIngredientItems: [],
    };
  },
  computed: {
    dialog() {
      return this.dialogI;
    },
  },
  props: {
    dialogI: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    searchIngredient() {
      this.ingredients = this.ingredients.filter((ingredient) => {
        return (
          ingredient.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        );
      });
    },
    closeModal() {
      this.$emit("closeDialog");
    },

    onOrderReceiptChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      this.previewUrl = URL.createObjectURL(files[0]);
      if (!files.length) {
        this.dragging = false;
        return;
      }
      this.order.receiptImageUrl = files[0];
      this.dragging = false;
    },

    removeOrderReceipt() {
      this.order.receiptImageUrl = "";
    },

    addOnIngredientsArr() {
      let selectedItems = [];
      this.selected.map((id) => {
        const selectedIngredients = this.order.ingredientOrderDetails.filter(
          (ingredient) => ingredient.ingredientId === id
        );
        if (selectedIngredients.length) {
          selectedItems.push(selectedIngredients[0]);
        } else {
          const selectedItem = this.ingredients.find(
            (ingredient) => ingredient.id === id
          );
          const item = {
            name: selectedItem.name,
            quantity: null,
            cost: null,
            tax: null,
            expiryDate: selectedItem.expiryDate || "",
            ingredientId: selectedItem.id,
          };
          selectedItems.push(item);
          this.expiryDateModel[item.name] = false;
        }
      });

      this.order.ingredientOrderDetails = selectedItems;
    },

    removeIngredientsArr(id) {
      const index = this.order.ingredientOrderDetails.findIndex(
        (ingredient) => ingredient.ingredientId === id
      );
      this.order.ingredientOrderDetails.splice(index, 1);
      this.selected.splice(this.selected.indexOf(id), 1);
    },

    async createOrder() {
      this.startLoading();
      let uploadedImage;

      if (
        this.order.receiptImageUrl &&
        typeof this.order.receiptImageUrl == "object"
      ) {
        uploadedImage = await S3UploadServce.singleUpload(
          this.order.receiptImageUrl,
          "registration"
        );
      }

      const ingredientOrderDetails = this.order.ingredientOrderDetails.map(
        (ingredient) => {
          return {
            quantity: parseInt(ingredient.quantity),
            cost: parseInt(ingredient.cost),
            tax: parseInt(ingredient.tax),
            expiryDate: ingredient.expiryDate,
            ingredientId: parseInt(ingredient.ingredientId),
          };
        }
      );
      this.$apollo
        .mutate({
          mutation: gql`
            mutation ($createOrderInput: CreateOrderInput!) {
              createOrder(createOrderInput: $createOrderInput) {
                id
              }
            }
          `,
          variables: {
            createOrderInput: {
              supplierId: parseInt(this.order.supplierId),
              orderDate: this.order.orderDate,
              receivedDate: this.order.receivedDate,
              receiptImageUrl: uploadedImage?.fullPath || "",
              farmId: 345,
              ingredientOrderDetails,
            },
          },
        })
        .then((response) => {
          console.log("response", response);
          this.$emit("closeDialog");
          this.stopLoading();
          this.$notify({
            title: "Order created successfully ",
            text: "Order created successfully.",
            type: "success",
            position: "top right",
          });
          this.$emit("orderCreated");
        })
        .catch((err) => {
          console.log("err", err);
          this.stopLoading();
        });
    },
  },
  mixins: [loadingMixin],
};
</script>

<style lang="scss" scoped>
.dropZone {
  position: relative;
  padding: 30px;
  background: #ffffff;
  border: 1px dashed #d2d2d2;
  border-radius: 5px;
}

.dropZone:hover {
  border: 2px solid #00bd73;
}

.dropZone:hover .dropZone-title {
  color: #00bd73;
}
.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.dropZone-over {
  background: #5c5c5c;
  opacity: 0.8;
}

.dropZone-uploaded {
  padding: 30px;
  background: #ffffff;
  border-radius: 5px;
  position: relative;
  border: 1px dashed #eee;
}

.removeFile {
  color: red;
  margin-left: 15px;
}

::v-deep .theme--light.v-chip:not(.v-chip--active) {
  background: #ffb443;
  color: #ffffff;
}

.column_wrapper {
  display: flex;
  max-height: 100px;
  flex-flow: column wrap;
}
</style>
